"use strict";

var _defineProperty = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Route = void 0;
/**
 * Represents an arbitrary route relative to an ArangoDB database.
 */

var Route = /*#__PURE__*/function () {
  /**
   * @internal
   * @hidden
   */
  function Route(db) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Route);

    if (!path) path = "";else if (path.charAt(0) !== "/") path = "/".concat(path);
    this._db = db;
    this._path = path;
    this._headers = headers;
  }
  /**
   * Creates a new route relative to this route that inherits any of its default
   * HTTP headers.
   *
   * @param path - Path relative to this route.
   * @param headers - Additional headers that will be sent with each request.
   *
   * @example
   * ```js
   * const db = new Database();
   * const foxx = db.route("/my-foxx-service");
   * const users = foxx.route("/users");
   * ```
   */


  _createClass(Route, [{
    key: "route",
    value: function route(path, headers) {
      if (!path) path = "";else if (path.charAt(0) !== "/") path = "/".concat(path);
      return new Route(this._db, this._path + path, _objectSpread(_objectSpread({}, this._headers), headers));
    }
    /**
     * Performs an arbitrary HTTP request relative to this route and returns the
     * server response.
     *
     * @param options - Options for performing the request.
     *
     * @example
     * ```js
     * const db = new Database();
     * const foxx = db.route("/my-foxx-service");
     * const res = await foxx.request({
     *   method: "POST",
     *   path: "/users",
     *   body: {
     *     username: "admin",
     *     password: "hunter2"
     *   }
     * });
     * ```
     */

  }, {
    key: "request",
    value: function request(options) {
      var opts = _objectSpread({}, options);

      if (!opts.path || opts.path === "/") opts.path = "";else if (!this._path || opts.path.charAt(0) === "/") opts.path = opts.path;else opts.path = "/".concat(opts.path);
      opts.basePath = this._path;
      opts.headers = _objectSpread(_objectSpread({}, this._headers), opts.headers);
      opts.method = opts.method ? opts.method.toUpperCase() : "GET";
      return this._db.request(opts);
    }
  }, {
    key: "delete",
    value: function _delete() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var path = typeof args[0] === "string" ? args.shift() : undefined;
      var qs = args[0],
          headers = args[1];
      return this.request({
        method: "DELETE",
        path: path,
        qs: qs,
        headers: headers
      });
    }
  }, {
    key: "get",
    value: function get() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var path = typeof args[0] === "string" ? args.shift() : undefined;
      var qs = args[0],
          headers = args[1];
      return this.request({
        method: "GET",
        path: path,
        qs: qs,
        headers: headers
      });
    }
  }, {
    key: "head",
    value: function head() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var path = typeof args[0] === "string" ? args.shift() : undefined;
      var qs = args[0],
          headers = args[1];
      return this.request({
        method: "HEAD",
        path: path,
        qs: qs,
        headers: headers
      });
    }
  }, {
    key: "patch",
    value: function patch() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      var path = typeof args[0] === "string" ? args.shift() : undefined;
      var body = args[0],
          qs = args[1],
          headers = args[2];
      return this.request({
        method: "PATCH",
        path: path,
        body: body,
        qs: qs,
        headers: headers
      });
    }
  }, {
    key: "post",
    value: function post() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      var path = typeof args[0] === "string" ? args.shift() : undefined;
      var body = args[0],
          qs = args[1],
          headers = args[2];
      return this.request({
        method: "POST",
        path: path,
        body: body,
        qs: qs,
        headers: headers
      });
    }
  }, {
    key: "put",
    value: function put() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      var path = typeof args[0] === "string" ? args.shift() : undefined;
      var body = args[0],
          qs = args[1],
          headers = args[2];
      return this.request({
        method: "PUT",
        path: path,
        body: body,
        qs: qs,
        headers: headers
      });
    }
  }]);

  return Route;
}();

exports.Route = Route;